// 获取是否是私有化环境
export function getIsPriv() {
  return String(process.env.REACT_APP_IS_PRIV) === 'true';
}
